import { SLICE_NAME, SelectedTransactionsSliceState } from 'slices/selectedTransactionsSlice';
import { RootState } from 'store';

export const selectedTransactionsStateSelector = (
  state: RootState,
): SelectedTransactionsSliceState => state[SLICE_NAME];

export const selectedTransactionsSelector = (state: RootState): (string | number)[] =>
  selectedTransactionsStateSelector(state)?.selectedTransactions;
